import React from 'react';
import { useLanguage } from './languageContext';
import './LanguageToggle.css';

function LanguageToggle() {
  const { language, setLanguage } = useLanguage();
  const isHindi = language === 'hi';

  return (
    <div className="lang-switch-shell" data-no-translate="true">
      <button
        type="button"
        className={`lang-text-btn ${!isHindi ? 'active' : ''}`}
        aria-label="Switch language to English"
        onClick={() => setLanguage('en')}
      >
        EN
      </button>
      <button
        type="button"
        className={`lang-text-btn ${isHindi ? 'active' : ''}`}
        aria-label="Switch language to Hindi"
        onClick={() => setLanguage('hi')}
      >
        HI
      </button>
    </div>
  );
}

export default LanguageToggle;
